export interface Lead {
  smartAssistant: string;
  email?: string;
  name?: string;
  phone?: string;
  createdAt: number;
  updatedAt: number;
}

export interface GetAllSmartAssistantLeadsDto {
  smartAssistantId: string;
  getSmartAssistantLeadsQueryDto: GetSmartAssistantLeadsQueryDto;
}

export interface GetSmartAssistantLeadsQueryDto {
  start?: number;
  end?: number;
}

export interface ExportSmartAssistantLeadsDto {
  smartAssistantId: string;
  query: GetSmartAssistantLeadsQueryDto;
  type: LeadsExportType;
}

export enum LeadsExportType {
  JSON = 'JSON',
  CSV = 'CSV'
}

export const LEADS_EXPORT_TYPE_TO_MIME_TYPE = new Map([
  [LeadsExportType.JSON, 'application/json'],
  [LeadsExportType.CSV, 'text/csv']
]);

export const LEADS_EXPORT_TYPE_TO_FILE_EXTENSION = new Map([
  [LeadsExportType.JSON, 'json'],
  [LeadsExportType.CSV, 'csv']
]);
